import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CheckLoginGuard {
  private _authService = inject(AuthService);
  constructor(private router: Router) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const user = await this._authService.getCurrentUser();
    const emptyTok = {
      claims: {
        roles: [],
        status: ''
      }
    } as any;
    const token = user ? await this._authService.getIdTokenResult() : emptyTok;
    const roles: string[] = token.claims.roles || [];
    const status: string = token.claims.status || '';
    const isLoggedIn =
      !!user &&
      user.emailVerified &&
      (roles.some((role) => {
        return ['admin'].indexOf(role) > -1;
      }) ||
        (status === 'activated' &&
          roles.some((role) => {
            return ['wholesale'].indexOf(role) > -1;
          })));
    if (isLoggedIn) {
      await this.router.navigate(['/wholesale']);
    }
    return !isLoggedIn;
  }
}
